import { Button } from "design-system/atoms/Button"
import { isFilled } from "lopermut"
import { ArrowRight } from "lucide-react"
import { useTranslation } from "react-i18next"

type EmptyStateProps = {
  tab: "installed" | "marketplace"
  onChangeTab: (tab: "installed" | "marketplace") => void
  search: string
}

export function EmptyState({ tab, onChangeTab, search }: EmptyStateProps) {
  const { t } = useTranslation()

  const hasSearch = isFilled(search)

  if (hasSearch) {
    return (
      <div className="py-20 relative flex flex-col gap-4 items-center justify-center">
        <div className="flex flex-col gap-1 items-center justify-center">
          <h1 className="text-xl font-semibold">{t("capabilities.list.noSearchResults.title")}</h1>
          <p className="text-sm text-muted-foreground">
            {t("capabilities.list.noSearchResults.description")}
          </p>
        </div>
      </div>
    )
  }

  switch (tab) {
    case "installed":
      return (
        <div className="py-20 relative flex flex-col gap-4 items-center justify-center">
          <div className="flex flex-col gap-1 items-center justify-center">
            <h1 className="text-xl font-semibold">
              {t("capabilities.list.noInstalledCapabilities.title")}
            </h1>
            <p className="text-sm text-muted-foreground">
              {t("capabilities.list.noInstalledCapabilities.description")}
            </p>
          </div>
          <Button onClick={() => onChangeTab("marketplace")}>
            <span>{t("capabilities.list.noInstalledCapabilities.cta")}</span>
            <ArrowRight className="size-4" />
          </Button>
        </div>
      )
    case "marketplace":
      return (
        <div className="py-20 relative flex flex-col gap-4 items-center justify-center">
          <div className="flex flex-col gap-1 items-center justify-center">
            <h1 className="text-xl font-semibold">
              {t("capabilities.list.noMarketplaceCapabilities.title")}
            </h1>
            <p className="text-sm text-muted-foreground">
              {t("capabilities.list.noMarketplaceCapabilities.description")}
            </p>
          </div>
        </div>
      )
  }
}
